// extracted by mini-css-extract-plugin
export default {"flex":"Flex_flex__CTp4J"};